import React from "react";
import { useGetStudentMyCourseQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import { Link } from 'react-router-dom';
import ExpiredCourseModal from "./ExpiredCourseModal";
import Loader from '../../../utils/Loader';

export default function FreeCourseComp() {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');
    const {
        data: StudentMyCourse,
        isLoading: isGetLoading,
    } = useGetStudentMyCourseQuery({ pageUrl, params: ''  });
    if(isGetLoading ) return  <Loader></Loader>
         return(
                <>
                
                { 
                    StudentMyCourse?.data?.map((item) => {   
                        return (
                            <>
                            
                            {(item?.course?.course_type ===0) ?
                               
                               <div className="col-md-4 col-xs-12 col-sm-12">
                                        
                                        <div className="card">
                                            <div className="card-header">

                                                {item?.end_date < formattedDate ? 
                                                <button className="dropdown-item"  data-bs-toggle="modal" data-bs-target="#fullscreenModal" >
                                                    <img src={item?.course?.course_image} height={200} style={{ width:'100%',height:'15vw','objectFit': 'cover'}} />{item?.course_type}
                                                </button>
                                                :
                                                <Link to={`/free-course-topic/${item.activity}/1`}>
                                                    <img src={item?.course?.course_image} height={200} style={{ width:'100%',height:'15vw','objectFit': 'cover'}} />
                                                </Link>

                                                }
                                                
                                            </div>
                                            <div className="card-body">
                                                
                                                {item?.end_date < formattedDate ? 
                                                    <>
                                                        <button className="dropdown-item"  data-bs-toggle="modal" data-bs-target="#fullscreenModal" >
                                                            <p className='text-warning'>{item?.course?.course_name}</p>
                                                        </button>
                                                        <p>{item?.end_date}</p>
                                                        <p>Type: Free Course</p>
                                                        <ExpiredCourseModal />
                                                    </>
                                                
                                                :
                                                    <>
                                                         <Link to={`/free-course-topic/${item.activity}/1`}>
                                                            <p>{item?.course?.course_name}</p>

                                                        <p>Expiry Date: {item?.end_date}</p>
                                                        <p>Type: Free Course</p>
                                                        </Link>
                                                        
                                                    </>
                                                }                                            
                                            </div>
                                            
                                        </div>
                                    </div> 
                               
                                :
                                ''
                            }
                            </>                                        
                        )
                    })
                }
                </>
            )
     
}
